import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class GameButton extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {integer} radius
   * @param {number} color
   * @param {integer} size
   */
  constructor(scene, radius, color = 0x29b24b, txt, size = 22) {
    super(scene);

    this.radius = radius;
    this.color = color;

    this.bg = this.scene.add.circle(0, 0, radius, this.color).setStrokeStyle(6, 0xFFFFFF);
    this.add(this.bg);

    this.lbl = ABCyaPhaser.Text.addText(0, 0, size, 0xffffff, FontKeys._BPreplay, txt, this, true).setOrigin(0.5)
      .setResolution(2);

    ABCyaPhaser.Container.setContainerInteractive(this, true);
  }
}